import { useCallback, useState } from "react";
import DevButton from "./DevButton";
import { csrfFetch } from "@lib/csrfFetch";

interface DevResetButtonProps {
  /** The URL to DELETE (e.g. `/test/deploys/123/restart`) */
  endpoint: string;
  /** Confirmation dialog text */
  confirmMessage: string;
  /** Button label */
  label: string;
  /** Label while request is in-flight */
  loadingLabel?: string;
  /** Render outside development too (e.g. admin-only tools in production). */
  forceShow?: boolean;
}

/**
 * Dev-only button that DELETEs an endpoint and reloads the page.
 * Used for thread/deploy/chat reset buttons across pages.
 */
export default function DevResetButton({
  endpoint,
  confirmMessage,
  label,
  loadingLabel,
  forceShow,
}: DevResetButtonProps) {
  const [loading, setLoading] = useState(false);

  const handleClick = useCallback(async () => {
    if (!confirm(confirmMessage)) return;

    setLoading(true);
    try {
      await csrfFetch(endpoint, { method: "DELETE" });
      window.location.reload();
    } catch (e) {
      console.error(`Failed: ${endpoint}`, e);
      setLoading(false);
    }
  }, [endpoint, confirmMessage]);

  return (
    <DevButton onClick={handleClick} disabled={loading} forceShow={forceShow}>
      {loading ? (loadingLabel ?? "Resetting...") : label}
    </DevButton>
  );
}
